import axiosInstance from '@/api/axiosInstance'
import { settingsService } from '@/services/settingsService'

const basePath = settingsService.identityApiBaseUrl

/** One-shot Bearer to mint `orbviz_auth_session`; subsequent IAM calls use the cookie only. */
export const createBackendSession = async (accessToken: string) => {
  await axiosInstance.post(`${basePath}/v1/session`, undefined, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    withCredentials: true,
  })
}

export const clearBackendSession = async () => {
  await axiosInstance.delete(`${basePath}/v1/session`, {
    withCredentials: true,
  })
}
